module.exports = __webpack_public_path__ + "img/gray-90rotate-icon-clockwise.75c28a99.png";